import React, { memo } from 'react';
export const StorySection = () => {
  return <section className="mb-10" data-id="element-175">
      <div className="bg-white p-6 border border-gray-200 rounded-lg" data-id="element-176">
        <p className="mb-4 text-gray-700 text-lg" data-id="element-177">
          I had become a prisoner in my own body.
        </p>
        <p className="mb-4 text-gray-700 text-lg" data-id="element-178">
          My wife watched helplessly as I transformed from the active husband
          and father she married into someone who winced getting up from a
          chair. The worst part? I could see the worry in her eyes every time I
          struggled with simple tasks that used to be effortless.
        </p>
        <p className="mb-6 text-gray-700 text-lg" data-id="element-179">
          I wasn't just dealing with pain anymore – I was fighting to get my
          life back.
        </p>
        <div className="flex flex-col md:flex-row gap-6 mb-6" data-id="element-180">
          <div className="md:w-1/2" data-id="element-181">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jVeH3J9xnpQBzbmGy9JSnq/ChatGPT_Image_Jun_27%2C_2025%2C_12_00_21_AM.png" alt="Man sitting on bed experiencing back pain" className="rounded-lg w-full h-56 object-cover mb-4" data-id="element-182" />
          </div>
          <div className="md:w-1/2" data-id="element-183">
            <p className="mb-4 text-gray-700 text-lg" data-id="element-184">
              Like most people in my situation, I started what I now call my
              "pillow saga." I tried everything: stacking regular pillows
              between my knees, expensive memory foam wedges that went flat
              after a month, even those weird-shaped "ergonomic" cushions that
              promised the world but delivered nothing.
            </p>
            <p className="text-gray-700 text-lg" data-id="element-185">
              Each failure felt like another door slamming shut on my hope for
              relief.
            </p>
          </div>
        </div>
        <p className="mb-4 text-gray-700 text-lg" data-id="element-186">
          My doctor's solution? More painkillers. When I expressed concern about
          long-term dependency, he just shrugged and said, "Sometimes you have
          to accept that chronic pain is your new normal."
        </p>
        <p className="mb-4 text-gray-700 text-lg" data-id="element-187">
          New normal? I refused to believe that at 47 years old, I was destined
          to live the rest of my life as a "sciatica sufferer" instead of the
          active father and provider I used to be.
        </p>
        <p className="mb-4 text-gray-700 text-lg" data-id="element-188">
          So I took matters into my own hands and dove deep into research,
          spending countless hours in online forums, reading medical journals,
          and connecting with others who were trapped in the same devastating
          cycle.
        </p>
        <p className="font-bold text-2xl text-blue-800 mb-4" data-id="element-189">
          That's when I discovered something that changed everything.
        </p>
      </div>
    </section>;
};